import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import OurServicePillars from "./sections/OurServicePillars";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <OurServicePillars />
      <Footer />
    </div>;
}